import userSettingsReducer from './userSettingsReducer';

export default userSettingsReducer;
